// extracted by mini-css-extract-plugin
module.exports = {"displayMode":"TooltipConfig_displayMode__1a1y2","title":"TooltipConfig_title__36HMa"};